import PropTypes from "prop-types";
import { styled, alpha } from "@mui/material/styles";
import {
  Toolbar,
  OutlinedInput,
  InputAdornment,
  Grid,
  TextField,
  Autocomplete,
  Button,
  Paper,
} from "@mui/material";
import Iconify from "../../../../components/iconify";
import { usePersistentState } from "../../../../contexts/global-context";
import { useEffect, useState } from "react";
import { GetLocalStorage } from "../../../../utils/local-storage";
import { GET } from "../../../../config/https";
import APIS from "../../../../config/api";
import FullScreenLoader from "../../../../components/full-screen-loader";
import Color from "../../../../theme/color";
import { useNavigate } from "react-router-dom";

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 135,
  padding: theme.spacing(0, 1, 0, 1),
  [theme.breakpoints.down("sm")]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const StyledSearch = styled(OutlinedInput)(({ theme }: any) => ({
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": {
    width: "100%",
    boxShadow: theme.customShadows.z8,
  },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

TableToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  options: PropTypes.string,
  value: PropTypes.any,
  onSearch: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.any,
};

export default function TableToolbar({
  numSelected,
  filterName,
  onSearch,
  placeholder,
  options,
  value,
  onChange,
}: any) {
  const [state]: any = usePersistentState();
  const [loginInfo, setLoginInfo] = useState<any>(false);
  const [checked] = useState(true);
  const [userData, setUserData] = useState<any>({});
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    GetUserData();
  }, []);

  const GetUserData = async () => {
    let userData = GetLocalStorage("loginData");
    let params: any = {
      id: userData.id,
    };
    setLoader(true);
    await GET(APIS.GET_USER_BY_ID, params)
      .then((res: any) => {
        if (res?.isSuccess) {
          setUserData(res?.result);
        } else {
        }
      })
      .catch((error) => {
        setLoader(false);

        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
  }, [state.users]);
  const userRole = loginInfo.roles;

  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: "primary.main",
          bgcolor: "primary.lighter",
        }),
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={3}>
          <StyledSearch
            fullWidth
            size="small"
            value={filterName}
            onChange={onSearch}
            placeholder={placeholder}
            startAdornment={
              <InputAdornment position="start">
                <Iconify
                  icon="eva:search-fill"
                  sx={{ color: "text.disabled", width: 20, height: 20 }}
                />
              </InputAdornment>
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          {userRole?.name === "Host" ? (
            <Autocomplete
              size="small"
              disablePortal
              style={{ backgroundColor: "#fff", width: "100%" }}
              id="combo-box-demo"
              options={options}
              value={userData?.companyName}
              onChange={onChange}
              renderInput={(params) => (
                <TextField {...params} placeholder="Organizer" />
              )}
              PaperComponent={(props) => (
                <Paper
                  {...props}
                  style={{
                    ...props.style,
                    border: " 1px solid #acacac",
                  }}
                />
              )}
              disabled={checked}
            />
          ) : (
            <Autocomplete
              size="small"
              disablePortal
              style={{ backgroundColor: "#fff", width: "100%" }}
              id="combo-box-demo"
              options={options}
              value={value}
              onChange={onChange}
              renderInput={(params) => (
                <TextField {...params} placeholder="Organizer" />
              )}
              PaperComponent={(props) => (
                <Paper
                  {...props}
                  style={{
                    ...props.style,
                    border: " 1px solid #acacac",
                  }}
                />
              )}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={3}></Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          style={{ display: "flex", justifyContent: "end" }}
        >
          {" "}
          <Button
            variant="contained"
            style={{ backgroundColor: Color.primary }}
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => {
              navigate("/dashboard/event/add", {
                state: {
                  isEditable: false,
                },
              });
            }}
          >
            Add Event
          </Button>
        </Grid>
      </Grid>
      <FullScreenLoader open={loader} />
    </StyledRoot>
  );
}
